import { AppRoutes } from '@/routes/AppRoutes';

// Composition root. Providers (QueryClient, Router) are mounted in main.tsx;
// App renders the application's route tree.
export default function App() {
  return <AppRoutes />;
}
